function fn_comp_models_detail() {
    var $fn = $(".comp_models_detail");

    if($fn.length){
        var gallery = $fn.find("[data-lib-gallery]");
        if(gallery.length) {
            gallery.fancybox({
                selector: ".lib--gallery-item",
                transitionEffect: "slide",
                animationEffect: "zoom",
                hideScrollbar: false,
                loop: true,
                buttons: [
                    "close"
                ]
            });
        }

        var slider = $fn.find("[data-lib-slider]");
        if(slider.length) {
            slider.each(function () {
                var sliderElm = $(this);
                var options = sliderElm.data("lib-slider");

                sliderElm.slick({
                    dots: options["dots"],
                    infinite: options["infinite"],
                    slidesToShow: 1,
                    prevArrow: "<button type=\"button\" class=\"slick-prev\"><span class=\"icon--arrow-left\"></span></button>",
                    nextArrow: "<button type=\"button\" class=\"slick-next\"><span class=\"icon--arrow-right\"></span></button>"
                });
            })
        }
    }
}